// ===========================
// セレクターの定義
export const qformFields = {
    inquiryType: '.quform-field-1_20',
    name: '.quform-field-1_18',
    email: '.quform-field-1_4',
    phone: '.quform-field-1_5',
    detail: '.quform-field-1_6',
    brand: '.quform-field-1_21',
    width: '.quform-field-1_22',
    depth: '.quform-field-1_29',
    height: '.quform-field-1_31',
    boughtPeriod: '.quform-field-1_33',
    concern: '.quform-field-1_32'
};

// DOM要素の定義 (初期化時に取得)
export const qformElements = {
    get contactPageHeader() { return document.querySelector('.js-page-header--contact'); },
    get formStep1() { return document.querySelector('.quform-page-1_1'); },
    get quformContainer() { return document.querySelector('.quform-elements'); },
    get quformPages() { return document.querySelectorAll('.quform-element-page'); },
    headerObserveClassName: 'quform-current-page'
};

/**
 * Quformの各フィールドの値をリアルタイムに反映させるイベントを初期化
 */
export function initQformElements() {
    const $ = jQuery;

    // お問い合わせ種別
    $(qformFields.inquiryType).on('change', function () {
        $('#inquiry-type-value').text($(this).val());
    });

    // 名前
    $(qformFields.name).on('change', function () {
        $('#name-value').text($(this).val());
    });

    // メールアドレス
    $(qformFields.email).on('change', function () {
        $('#email-value').text($(this).val());
    });

    // 電話番号
    $(qformFields.phone).on('change', function () {
        $('#phone-value').text($(this).val());
    });

    // 内容の詳細
    $(qformFields.detail).on('change', function () {
        $('#detail-value').text($(this).val());
    });

    // ブランド名・型番
    $(qformFields.brand).on('change', function () {
        $('#brand-value').text($(this).val());
    });

    // 幅(W)
    $(qformFields.width).on('change', function () {
        $('#width-value').text($(this).val());
    });

    // 奥行き(D)
    $(qformFields.depth).on('change', function () {
        $('#depth-value').text($(this).val());
    });

    // 高さ(H)
    $(qformFields.height).on('change', function () {
        $('#height-value').text($(this).val());
    });

    // 購入時期
    $(qformFields.boughtPeriod).on('change', function () {
        $('#bought-period-value').text($(this).val());
    });

    // 状態・気になる点
    $(qformFields.concern).on('change', function () {
        $('#concern-value').text($(this).val());
    });
}